export var sizes = {
  size0: 'size-0',
  size10: 'size-10',
  size25: 'size-25',
  size40: 'size-40',
  size50: 'size-50',
  size65: 'size-65',
  size75: 'size-75',
  size85: 'size-85',
  size100: 'size-100',
  size115: 'size-115',
  size130: 'size-130',
  size150: 'size-150',
  size160: 'size-160',
  size175: 'size-175',
  size185: 'size-185',
  size200: 'size-200',
  size225: 'size-225',
  size250: 'size-250',
  size275: 'size-275',
  size300: 'size-300',
  size350: 'size-350',
  size400: 'size-400',
  size450: 'size-450',
  size500: 'size-500',
  size550: 'size-550',
  size600: 'size-600',
  size700: 'size-700',
  size800: 'size-800',
  size900: 'size-900',
  size1000: 'size-1000',
  size1200: 'size-1200',
  size1250: 'size-1250',
  size1600: 'size-1600',
  size1700: 'size-1700',
  size2000: 'size-2000',
  size2400: 'size-2400',
  size3000: 'size-3000',
  size3400: 'size-3400',
  size3600: 'size-3600',
  size4600: 'size-4600',
  size5000: 'size-5000',
  size6000: 'size-6000'
};
export var staticSizes = {
  size0: 'static-size-0',
  size10: 'static-size-10',
  size25: 'static-size-25',
  size40: 'static-size-40',
  size50: 'static-size-50',
  size65: 'static-size-65',
  size75: 'static-size-75',
  size85: 'static-size-85',
  size100: 'static-size-100',
  size115: 'static-size-115',
  size130: 'static-size-130',
  size150: 'static-size-150',
  size160: 'static-size-160',
  size175: 'static-size-175',
  size185: 'static-size-185',
  size200: 'static-size-200',
  size225: 'static-size-225',
  size250: 'static-size-250',
  size300: 'static-size-300',
  size350: 'static-size-350',
  size400: 'static-size-400',
  size450: 'static-size-450',
  size500: 'static-size-500',
  size550: 'static-size-550',
  size600: 'static-size-600',
  size700: 'static-size-700',
  size800: 'static-size-800',
  size900: 'static-size-900',
  size1000: 'static-size-1000',
  size1200: 'static-size-1200',
  size1250: 'static-size-1250',
  size1600: 'static-size-1600',
  size1700: 'static-ize-1700',
  size2000: 'static-size-2000',
  size2400: 'static-size-2400',
  size3000: 'static-size-3000',
  size3400: 'static-size-3400',
  size3600: 'static-size-3600',
  size4600: 'static-size-4600',
  size5000: 'static-size-5000',
  size6000: 'static-size-6000'
};